import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { fechaCorta } from '../pages/agencia/ui';

/* Cuándo entró la plata, al lado del estado del cobro.

   Por defecto es el día en que se lo marcó como pagado, que es lo correcto casi
   siempre. Pero el pago puede haber entrado el viernes y registrarse el lunes,
   o pasarse de largo una semana: esa fecha es la que arma los reportes de
   facturación, así que se puede corregir.

   En el portal se muestra igual pero sin editar: `editable` viene en false. */

export default function FechaPago({ cobro, editable = false, onCambio }) {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState('');
  const [guardando, setGuardando] = useState(false);

  if (cobro.estado !== 'pagado') return null;
  const cuando = cobro.pagado_el;

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await api.put(`/agency/cobros/${cobro.id}/pago`, { fecha: valor });
      toast.success('Fecha de pago actualizada');
      setEditando(false);
      if (onCambio) onCambio(valor);
    } catch (err) { toast.error(err.response?.data?.error || 'No se pudo guardar'); }
    finally { setGuardando(false); }
  };

  const texto = cuando ? fechaCorta(cuando) : 'sin fecha';

  if (!editable) {
    return <span style={{ fontSize: 11.5, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{texto}</span>;
  }

  return (
    <>
      <button className="celda-editable" title="Cambiar la fecha en que se cobró"
        onClick={() => { setValor(String(cuando || '').slice(0, 10)); setEditando(true); }}
        style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>
        {texto}<Pencil size={10} />
      </button>

      {editando && (
        <div className="modal-overlay" onClick={() => setEditando(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <h2>¿Cuándo se cobró?</h2>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', margin: '4px 0 16px' }}>
              {cobro.cliente ? cobro.cliente + ' · ' : ''}{cobro.concepto || cobro.servicio || 'Cobro'}
            </p>
            <form onSubmit={guardar}>
              <div className="form-group">
                <label>Se cobró el</label>
                <input type="date" value={valor} autoFocus onChange={e => setValor(e.target.value)} />
                <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 5 }}>
                  Es la fecha con la que cuenta en los reportes de facturación.
                </div>
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setEditando(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={guardando || !valor}>Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
